<template>
  <b-form-select v-model="currentValue" class="input_wrapper" @change="onchange">
    <option v-if="Object.keys(options).length > 0" v-for="(value, key, idx) in options" :key="idx" :value="key">
      {{value}}
    </option>
    <option v-if="Object.keys(options).length == 0" v-for="(value, idx) in options" :key="idx" :value="idx">
      {{value}}
    </option>
  </b-form-select>
</template>

<script>
export default {
  name: "CSelect",
  props:["options"],
  data() {
    return {
      currentValue:0,
    }
  },
  methods:{
    onchange(){
      this.$emit('input', this.currentValue);
    }
  },
  mounted() {
    this.currentValue = this.$attrs.value;
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/controls/CSelect.vue